import { create } from 'zustand';
import type { ReactNode } from 'react';

// Слот центральной кнопки mobile bottom bar. Страницы регистрируют
// свою контекстную кнопку через setCenter(node) в useEffect, а при
// размонтировании — setCenter(null). Это избавляет от prop-drilling
// «страница → Layout → MobileBottomBar».

interface Store {
  center: ReactNode | null;
  setCenter: (node: ReactNode | null) => void;
}

const useBottomBarStore = create<Store>((set) => ({
  center: null,
  setCenter: (node) => set({ center: node }),
}));

export default useBottomBarStore;
